module.exports = __webpack_public_path__ + "static/media/instagram.87907951.svg";